import React, { Component } from 'react';
import { Col, Label, FormGroup } from "reactstrap";
import Select from 'react-select';
import { montarSelectOption, setTemaSeletor } from "../../../utils/formatar";
import _ from 'lodash';

export default class FormSelect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mostrarOpcoes: !this.props.buscaMinima
        };
    };

    componentDidMount() {

    }


    onInputChange = (inputValue) => {
        console.log(inputValue)
        /*  Se existir busca mínima, verifica se a busca ja tem tamanho suficiente
            Se não existir busca mínima, carrega opções quando elas ainda não existe.
        */
        // if (!this.props.buscaMinima || inputValue.length >= this.props.buscaMinima) {
        //     this.setState({
        //         mostrarOpcoes: true
        //     });
        // } else {
        //     this.setState({
        //         mostrarOpcoes: false
        //     });
        // }
        this.props.onInputChange(inputValue)
    };

    filtro(option, searchText) {
        if (option.label && option.label.toLowerCase().includes(searchText.toLowerCase())) {
            return true;
        } else {
            return false;
        }
    };

    noOptionsMessage(buscaMinima, inputValue) {
        // Props não funciona aqui :/
        /*  Mesma verificação de onInputChange */
        if (!buscaMinima || (inputValue && inputValue.length >= buscaMinima)) {
            return "Sem opções";
        } else {
            return `Informe ${buscaMinima} ou mais caracteres`;
        }
    };

    handleChange = (event) => {
        this.props.onChange(event, event);
    };

    handleBlur = (event) => {
        if (this.props.onBlur) {
            this.props.onBlur(event);
        }
    };

    render() {
        const options = this.props.options ? this.props.options : montarSelectOption(this.props.itensValor, this.props.itensLabel, this.props.itens);
        const selectedValue = _.get(this.props.objeto, this.props.dado);
        const val = options.filter(option => option.value == selectedValue);

        return (
            <Col className={this.props.col ? this.props.col : "" || this.props.className ? this.props.className : ""}
                xs={this.props.xs ? this.props.xs : 'auto'}
                sm={this.props.sm ? this.props.sm : 'auto'}
                md={!this.props.col && this.props.md ? this.props.md : 'auto'}
                lg={this.props.lg ? this.props.lg : this.props.md ? this.props.md : 'auto'}
                xl={this.props.xl ? this.props.xl : this.props.lg ? this.props.lg : this.props.md ? this.props.md : 'auto'}
            >
                {/* <Col className={} xs={this.props.xs ? this.props.xs : 'auto'} sm={this.props.sm ? this.props.sm : 'auto'} md={this.props.md ? this.props.md : 'auto'}> */}
                <FormGroup>
                    {this.props.titulo && <Label>{this.props.titulo} {this.props.obrigatorio ? <span className="label-danger">*</span> : ""} </Label>}
                    <Select className="select"
                        id='teste'
                        placeholder={this.props.placeholder ? this.props.placeholder : "Insira para pesquisar."}
                        noOptionsMessage={(inputValue) => this.noOptionsMessage(this.props.buscaMinima, inputValue.inputValue)}
                        isClearable={!this.props.naoLimpar}
                        isSearchable={options.length >= 0}
                        value={val}
                        isDisabled={this.props.bloqueado ? this.props.bloqueado : false}
                        onChange={this.handleChange}
                        onInputChange={this.onInputChange}
                        menuPlacement="auto"
                        options={this.state.mostrarOpcoes ? options : []}
                        theme={theme => setTemaSeletor(theme)}
                        filterOption={this.filtro}
                        onBlur={this.handleBlur}
                        
                    />
                {this.props.alerta
                    && <Col xs={12} className="col-label label-obrigatorio px-0">
                        <Label>{this.props.alerta}</Label>
                    </Col>
                }
                </FormGroup>
            </Col>
        )
    };
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/FormSelectPesquisa.js